import { scrollToRegistration } from "@/config";

const RegisterButton = ({ testId, className = "" }) => (
    <button
        type="button"
        onClick={scrollToRegistration}
        data-testid={testId}
        className={`inline-flex cursor-pointer items-center justify-center gap-2 whitespace-nowrap rounded-full bg-gradient-to-b from-[#4a90ff] to-[#1677FF] px-8 py-4 font-display text-sm font-extrabold uppercase tracking-wide text-white shadow-[0_12px_45px_-10px_rgba(22,119,255,0.75)] transition-colors duration-300 hover:from-[#5f9dff] hover:to-[#2f80ff] active:scale-[0.98] ${className}`}
    >
        Daftar Seminar Percuma
    </button>
);

export default RegisterButton;
